
define('jst!shared/_search_input',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<div class="search-input">\n  <div class="icon icon-16 icon-16-search <%= options[\'iconClass\'] ? options[\'iconClass\'] : \'\' %>"></div>\n  <input type="text" class="<%= inputClass %>" placeholder="<%= inputPlaceholderText %>" <%= options[\'tabindex\'] ? \'tabindex="{0}"\'.format(options[\'tabindex\']) : \'\' %> />\n</div>');
 });

